import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { UL, Link } from 'atoms'

const ListItem = styled.li`
  padding: 12px 24px;
  background: #f6f6f6;
  border-bottom: 1px solid #e2e2e2;
`

const Title = styled.span`
  color: #384047;
  margin: 0;
  font-weight: 700;
  font-size: 14px;
  display: block;
`

const Description = styled.span`
  margin: 8px 0 0;
  color: #afb2b7;
  font-weight: 300;
  display: block;
`

function AccordionBody(props) {
  const { links } = props
  if (links === undefined) {
    return null
  }
  return (
    <UL>
      {links.map((link, index) => {
        return (
          <ListItem key={`ListItem-${link.text}-${index}`}>
            <Link href={link.url}>
              <Title>{link.text}</Title>
              <Description>{link.description}</Description>
            </Link>
          </ListItem>
        )
      })}
    </UL>
  )
}

AccordionBody.propTypes = {
  links: PropTypes.array.isRequired,
}

export default AccordionBody



// WEBPACK FOOTER //
// ./src/organisms/Header/MobileHeader/components/AccordionBody.js